import { mapActions } from "vuex";

export const openUsernameDialog = {
  methods: {
    ...mapActions(["setUsername"]),
    openUsernameDialog(message) {
      this.dialog = this.$buefy.dialog.prompt({
        title: this.$t("user.usernameProfile"),
        message: message,
        inputAttrs: {
          placeholder: this.$t("user.usernamePlaceholder"),
          maxlength: 40
        },
        trapFocus: true,
        confirmText: "Ok",
        onCancel: () => this.goTo(),
        onConfirm: value => {
          let username = value;

          this.setUsername({
            username: username
          }).catch(message => {
            this.$buefy.toast.open({
              message: unescape(this.$t(message, { username: username })),
              type: "is-danger",
              duration: 5000,
              position: "is-top-right"
            });

            this.openUsernameDialog(this.$t("user.enterUserName"));
          });
        }
      });
    }
  }
};
